var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"100px"}},[_c('video-wrapper',{attrs:{"src":"https://sunlue.oss-cn-chengdu.aliyuncs.com/video/20FD75AEA17F4C06974376BBD6C39EF3.mp4","mode":"widthFix"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }